export default "__VITE_ASSET__DjENX_SX__"